import FpLogo from "@/assets/fp-logo.svg";
import { useRouter } from "@tanstack/react-router";
import { User } from "lucide-react";
import { memo } from "react";
import type { FpMessage } from "../../../schemas/codegen";

type AvatarProps = Pick<FpMessage, "sender">;

export const Avatar = memo(function Avatar({ sender }: AvatarProps) {
  return (
    <div className="w-7 aspect-square flex items-center justify-center rounded-md bg-primary/10 overflow-hidden">
      {sender === "agent" ? (
        <FpLogo className="w-full h-full text-default" />
      ) : (
        <UserAvatar />
      )}
    </div>
  );
});

function UserAvatar() {
  const router = useRouter();
  const { user } = router.options.context.auth;

  if (!user?.avatarUrl) {
    return <User className="w-full h-full" />;
  }

  return (
    <img
      src={user.avatarUrl}
      alt="User avatar"
      className="w-full h-full object-cover rounded-md"
    />
  );
}
